module.exports = __webpack_public_path__ + "static/img/addquestion-nps.56ef026.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/addquestion-nps.png
// module id = SqGv
// module chunks = 1